import React from 'react';
import { toast } from 'react-toastify';
import { IFrontTask, IPartnerCustomerRelationship } from "../../../../interfaces/ITask";
import { censorEmail } from "../../../../Functions/Functions";
import { FaStar } from "react-icons/fa";

interface TaskPartnerInfoProps {
  task: IFrontTask;
  partnerCustomer: IPartnerCustomerRelationship[];
  userRole: string;
}

const TaskPartnerInfo: React.FC<TaskPartnerInfoProps> = ({ task, partnerCustomer, userRole }) => {
  const isPriority = (task?.EhParceiroPrioritario ?? task?.ehParceiroPrioritario) === true;
  const handleCopy = (event: React.MouseEvent, text: string) => {
    event.preventDefault();
    event.stopPropagation();
    
    navigator.clipboard.writeText(text).then(() => {
      toast.success('📋 Copiado com sucesso!', {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }).catch((err) => {
      console.error('Erro ao copiar:', err);
      toast.error('❌ Erro ao copiar para a área de transferência', {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    });
  };

  const partnerInfoItems = [
    {
      label: "Parceiro",
      value: userRole === "Viewer" ? censorEmail(task.partnerEmail) : task.partnerEmail,
      copyValue: task.partnerEmail,
      icon: "🤝"
    },
    {
      label: "Cliente",
      value: userRole === "Viewer" ? censorEmail(task.customerEmail) : task.customerEmail,
      copyValue: task.customerEmail,
      icon: "👥"
    }
  ];

  // Para Viewer: não exibe emails, mas mostra indicação de prioridade
  if (userRole === "Viewer") {
    return isPriority ? (
      <div className="task-info-card">
        <h3>🏢 Informações do Parceiro</h3>
        <span style={{ margin: "4px 0 12px 0", display: "inline-flex", alignItems: "center" }}>
          <FaStar color="#f5c518" size={16} />
        </span>
      </div>
    ) : null;
  }

  return (
    <div className="task-info-card">
      <h3>🏢 Informações do Parceiro</h3>
      {isPriority ? (
        <span style={{ margin: "4px 0 12px 0", display: "inline-flex", alignItems: "center" }}>
          <FaStar color="#f5c518" size={16} />
        </span>
      ) : null}
      <div className="task-info-grid">
        {partnerInfoItems.map((item, index) => (
          <div key={index} className="task-info-item">
            <div className="task-info-icon">{item.icon}</div>
            <div className="task-info-content">
              <div className="task-info-label">{item.label}</div>
              <div className="task-info-value-container">
                <div className="task-info-value">{item.value}</div>
                {userRole !== "Viewer" && (
                  <button
                    className="copy-button"
                    onClick={(e) => handleCopy(e, item.copyValue)}
                    title="Copiar para área de transferência"
                    type="button"
                  >
                    📋
                  </button>
                )}
              </div>
            </div>
          </div>
        ))}
      </div>

      {partnerCustomer != null && partnerCustomer != undefined && partnerCustomer.length > 0 && (
        <div className="additional-partners">
          <h4 className="additional-partners-title">Parceiros Adicionais</h4>
          {partnerCustomer.map((pc, index) => (
            <div key={index} className="additional-partner-item">
              <div className="task-info-item">
                <div className="task-info-icon">🤝</div>
                <div className="task-info-content">
                  <div className="task-info-label">Parceiro {index + 2}</div>
                  <div className="task-info-value-container">
                    <div className="task-info-value">
                      {userRole === "Viewer" ? censorEmail(pc.partnerEmail) : pc.partnerEmail}
                    </div>
                    {userRole !== "Viewer" && (
                      <button
                        className="copy-button"
                        onClick={(e) => handleCopy(e, pc.partnerEmail)}
                        title="Copiar para área de transferência"
                        type="button"
                      >
                        📋
                      </button>
                    )}
                  </div>
                </div>
              </div>
              <div className="task-info-item">
                <div className="task-info-icon">👥</div>
                <div className="task-info-content">
                  <div className="task-info-label">Cliente {index + 2}</div>
                  <div className="task-info-value-container">
                    <div className="task-info-value">
                      {userRole === "Viewer" ? censorEmail(pc.customerEmail) : pc.customerEmail}
                    </div>
                    {userRole !== "Viewer" && (
                      <button
                        className="copy-button"
                        onClick={(e) => handleCopy(e, pc.customerEmail)}
                        title="Copiar para área de transferência"
                        type="button"
                      >
                        📋
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TaskPartnerInfo; 
